import { createAnalyticsGroup } from 'js/lib/analytics'

const initTrackingLink = (link) => {
  const trackingGroup = link.getAttribute('data-tracking-group')
  const trackingLabel = link.getAttribute('data-tracking-label')
  
  if (trackingGroup && trackingLabel) {
    const track = createAnalyticsGroup(trackingGroup)
    const currentPage = window.location.href
    
    link.addEventListener('click', () => {
      track('click', `${trackingLabel} from ${currentPage}`)
    })
  }
}

document.querySelectorAll('.js-c-ui-typography-a-tracking').forEach(initTrackingLink)
